import React, { useState, useContext } from 'react'

const cx = require('classnames')

interface TabViewProps {
  tabs: Tab[]
  children: any
}

interface Tab {
  id: string
  label: string
}

const CurTabCtx = React.createContext<string | null>(null)

export function Selector(props: TabViewProps) {
  const [ currentTab, setCurrentTab ] = useState<Tab>(props.tabs[0])

  return (
    <>
      <div className="row">
        <div className="col-12">
          <ul className="nav nav-tabs">
            { props.tabs.map((tab) =>
              <li key={tab.id} className="nav-item" role="presentation">
                <a className={cx('nav-link', {active: currentTab.id === tab.id})} href={window.location.href} onClick={() => setCurrentTab(tab)}>{tab.label}</a>
              </li>)
            }
          </ul>
        </div>
      </div>
      <div className="row">
        <CurTabCtx.Provider value={currentTab.id}>
            { props.children }
        </CurTabCtx.Provider>
      </div>
    </>
  )
}

interface TabViewContentProps {
  for: string
  children: any
}

export function Content(props: TabViewContentProps) {
  const currentTab = useContext(CurTabCtx)
  if (props.for == currentTab) {
    return (
      <div className="col-12">
        { props.children }
      </div>
    )
  } else {
    return null
  }
}